export default class Item {
  constructor({
    id,
    name,
    description,
    courseTypeName,
    logoPath,
    currentPrice,
    saleNum,
    headerImgPath,
    totalHours,
    orgInfoName,
    orgInfoId,
    orgInfoDes,
    isDiscount,
    isFree,
    oldPrice,
    courseTypeId,
    baseSaleNum,
    introduce,
    discountType,
    isHighSchool
  }) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.courseTypeName = courseTypeName;
    this.logoPath = logoPath;
    this.currentPrice = currentPrice;
    this.saleNum = saleNum;
    this.baseSaleNum = baseSaleNum;
    this.headerImgPath = headerImgPath;
    this.totalHours = totalHours;
    this.orgInfoName = orgInfoName;
    this.orgInfoId = orgInfoId;
    this.orgInfoDes = orgInfoDes;
    this.isHighSchool = isHighSchool;
    (this.courseTypeId = courseTypeId),
      (this.introduce = introduce),
      (this.isDiscount = isDiscount),
      (this.isFree = isFree),
      (this.oldPrice = oldPrice),
      (this.discountType = discountType);
  }
}
export function changeCourseItem(data) {
  // if (data.headerImgPath.findIndex('http') !== 0) {
  //   data.headerImgPath = imgUrl + data.headerImgPath
  // }
  return new Item({
    id: data.id,
    name: data.name,
    description: data.description,
    courseTypeName: data.courseTypeName,
    logoPath: data.logoPath,
    // 当前价格
    currentPrice: data.currentPrice,
    // 销售数量
    saleNum: data.saleNum,
    baseSaleNum: data.baseSaleNum,
    // 机构头像
    headerImgPath: data.headerImgPath,
    // 总课时
    totalHours: data.totalHours,
    // 机构名称
    orgInfoName: data.orgInfoName,
    // 机构ID
    orgInfoId: data.orgInfoId,
    // 机构介绍
    orgInfoDes: data.orgInfoDes,
    courseTypeId: data.courseTypeId,
    introduce: data.introduce,
    //是否折扣
    isDiscount: data.isDiscount,
    isFree: data.isFree,
    oldPrice: data.oldPrice,
    //限时1或限量2
    discountType: data.discountType,
    //是否是高校
    isHighSchool: data.isHighSchool
  });
}



// WEBPACK FOOTER //
// ./src/common/js/courseType.js